module.exports = __webpack_public_path__ + "assets/fb-08ae34c38e1287f2657ab26bd5be393f.svg";